var moment = require('moment')
var dateutils = require('./dateutils')

const state = {
  all: [],
  headers: ['jobNumber', 'status', 'createdDate', 'updatedDate'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  disablePaginationComponent: true,
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false,
  showGeneratingModal: false,
  showGeneratingSuccessModal: false,
  showGeneratingFailedModal: false,
  showCannotGenerateModal: false
}

const mutations = {
  setRowsPerPage: function (state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage
  },
  changePageNumber: function (state, newCurrentPage) {
    state.currentPage = newCurrentPage
    // console.log('CHanged state page number to: ' + state.currentPage)
  },
  updateTotalRows: function (state, newTotalRows) {
    state.totalRows = newTotalRows
    // console.log('Mutated totalRows to: ' + state.totalRows)
  },
  toggleShowLoadingAnimation: function (state, show) {
    state.showLoadingAnimation = show
  },
  toggleshowLoadingError: function (state, show) {
    state.showLoadingError = show
  },
  toggleShowNoResult: function (state, show) {
    state.showNoResult = show
  },
  setLoadingErrorMessage: function (state, message) {
    state.loadingErrorMessage = message
  },
  updateDownloadUrl: function (state, updatePackage) {
    console.log('Update download url to: ' + updatePackage.url + ' for job: ' + updatePackage.jobNumber)
    state.all.forEach(row => {
      if (row.jobNumber === updatePackage.jobNumber) {
        row.downloadUrl = updatePackage.url
      }
    })
  },
  toggleShowGeneratingModal: function (state, show) {
    state.showGeneratingModal = show
  },
  toggleShowGeneratingSuccessModal: function (state, show) {
    state.showGeneratingSuccessModal = show
  },
  toggleShowGeneratingFailedModal: function (state, show) {
    state.showGeneratingFailedModal = show
  },
  toggleShowCannotGenerateModal: function (state, show) {
    state.showCannotGenerateModal = show
  }
}

const getters = {
  getAll: function (state, getters, rootState) {
    return state.all
  },
  getHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.headers.length; i++) {
      let eachHeader = state.headers[i]
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      })
    }
    return extraHeaders
  }
}

const actions = {
  showAllClaimReportJobs (context, payload) {
    context.state.all = []

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    let importsCollectionName = 'batchReports'

    // count total rows
    let firstQuery = context.rootState.firestoreDB.collection(importsCollectionName)
    firstQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.docs.length)
    })

    if (context.state.currentPage === 1) {
      let docQuery = context.rootState.firestoreDB.collection(importsCollectionName)
        .orderBy(payload.orderBys, 'desc')
        .limit(context.state.rowsPerPage)
      docQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // console.log(doc.id + '=>' + doc.data())
          let documentData = doc.data()
          let invoiceObject = {}
          for (let eachProp in documentData) {
            let propName = eachProp
            // console.log('eachProp: ' + eachProp)
            if (propName === 'createdDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
              let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
              invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
            } else {
              invoiceObject[propName] = doc.data()[eachProp]
            }
            // invoiceObject[propName] = doc.data()[eachProp]
            // context.state.headers.push(propName)
          }
          invoiceObject['downloadUrl'] = ''
          context.state.all.push(invoiceObject)
        })
        context.commit('toggleShowLoadingAnimation', false)
        if (context.state.all.length === 0) {
          context.commit('toggleShowNoResult', true)
        }
      }).catch(function (err) {
        console.log('Error while fetching documents in imports collection: ' + err)
        context.commit('toggleShowLoadingAnimation', false)

        context.commit('toggleshowLoadingError', true)
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
      })
    } else {
      let lastRowShown
      if (context.state.currentPage === 2) {
        lastRowShown = context.state.rowsPerPage
      } else {
        lastRowShown = ((context.state.currentPage - 1) * context.state.rowsPerPage)
      }
      console.log('lastRowShown: ' + lastRowShown)
      let docQuery = context.rootState.firestoreDB.collection(importsCollectionName)
        .orderBy(payload.orderBys, 'desc')
      docQuery.get().then(function (querySnapshot) {
        let lastVisibleSnapshot = querySnapshot.docs[lastRowShown]

        let docSubQuery = context.rootState.firestoreDB.collection(importsCollectionName)
          .orderBy(payload.orderBys)
          .startAt(lastVisibleSnapshot)
          .limit(context.state.rowsPerPage)
        docSubQuery.get().then(function (subQuerySnapshot) {
          subQuerySnapshot.forEach(function (subDoc) {
            // console.log(subDoc.id + '=>' + subDoc.data())
            let documentData = subDoc.data()
            let invoiceObject = {}
            for (let eachProp in documentData) {
              let propName = eachProp
              // console.log('eachProp: ' + eachProp)
              if (propName === 'createdDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else if (propName === 'updatedDate' && subDoc.data()[eachProp]) {
                let m = moment(dateutils.toJsDate(subDoc.data()[eachProp]))
                invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
              } else {
                invoiceObject[propName] = subDoc.data()[eachProp]
              }
              // invoiceObject[propName] = subDoc.data()[eachProp]
              // context.state.headers.push(propName)
            }
            invoiceObject['downloadUrl'] = ''
            context.state.all.push(invoiceObject)
          })
          context.commit('toggleShowLoadingAnimation', false)
          if (context.state.all.length === 0) {
            context.commit('toggleShowNoResult', true)
          }
        })
      }).catch(function (err) {
        console.log('Error while fetching documents in imports collection: ' + err)
        context.commit('toggleShowLoadingAnimation', false)

        context.commit('toggleshowLoadingError', true)
        context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
      })
    }
  },
  downloadFileFromGCS (context, payload) {
    let firebaseStorageRef = context.rootState.fbStorage.ref()
    firebaseStorageRef.child('batchReports/' + payload.jobNumber + '/azip/claimsreports.zip').getDownloadURL().then(function (url) {
      console.log('Download url: ' + url)

      let updatePackage = {
        jobNumber: payload.jobNumber,
        url: url
      }
      context.commit('updateDownloadUrl', updatePackage)
    }).catch(function (error) {
      console.error(error)

      let updatePackage = {
        jobNumber: payload.jobNumber,
        url: ''
      }
      context.commit('updateDownloadUrl', updatePackage)
    })
  },
  generateClaimsReports (context, payload) {
    console.log('Generate claims reports')
    context.commit('toggleShowGeneratingModal', true)
    context.rootState.firestoreDB.collection('batchReports').get()
      .then(function (querySnapshot) {
        if (querySnapshot.size === 0) {
          context.dispatch('triggerTick')
          return
        }
        let hasUnfinishedJob = false
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            let data = doc.data()
            // console.log('status: ' + data.status)
            if (data.status !== 'READY_FOR_DOWNLOAD' && data.status !== 'FAILED_AND_STOPPED') {
              console.log('has pending job: ' + data.status)
              hasUnfinishedJob = true
            }
          }
        })
        if (hasUnfinishedJob) {
          context.commit('toggleShowCannotGenerateModal', true)
          context.commit('toggleShowGeneratingModal', false)
          context.dispatch('showAllClaimReportJobs', { orderBys: 'createdDate' })
        } else {
          context.dispatch('triggerTick')
        }
      })
  },
  triggerTick (context, payload) {
    console.log('Tick db to generate claim')
    let dataCommitted = false
    // let tickFailedError = null
    context.rootState.realtimeDb.ref('batchReport/').transaction(
      function (data) {
        if (data) {
          data.tick = Number(data.tick) + 1
        } else {
          data = {
            archiveJobNumber: 0,
            invoiceTick: 0,
            jobNumber: 1,
            lastParsedEmail: '',
            parsedEmails: 0,
            recordsToParsePerBatch: 100,
            tick: 1,
            totalUsers: 0
          }
        }
        return data
      },
      function (error, committed, snapshot) {
        if (error) {
          console.error('Tick update failed: ' + error)
          // tickFailedError = error
        }
        if (committed) {
          console.log('Updated tick')
          dataCommitted = true
        }
      }
    ).then(function () {
      context.dispatch('showAllClaimReportJobs', { orderBys: 'createdDate' })
      if (dataCommitted) {

      }
    }).catch(function (err) {
      context.dispatch('showAllClaimReportJobs', { orderBys: 'createdDate' })
      console.error(err)
    })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/generateclaimreportsmodule.js